<template>
	<div class="header-shell" :class="{ 'header-shell--topbar-hidden': !isTopBarVisible }">
		<div class="header-topbar">
			<div class="header-topbar__container">
				<div class="header-topbar__left">
					<NuxtLink :to="localePath('blog')" class="header-topbar__link">{{ i18nService.$tDynamic('components.nav', 'news') }}</NuxtLink>
					<NuxtLink :to="localePath('faq')" class="header-topbar__link">{{
						i18nService.$tDynamic('components.nav', 'frequent_questions')
					}}</NuxtLink>
					<a href="mailto:rezerwacje@carfree.pl" rel="nofollow" class="header-topbar__link header-topbar__mail-link">
						<GlobalIcon name="sms" class="header-topbar__mail-icon" :width="18" />
						rezerwacje@carfree.pl
					</a>
				</div>
				<div class="header-topbar__right">
					<ClientOnly>
						<ButtonOutlined v-if="!userStore.getUser" class="header-topbar__login-btn" :to="localePath('sign-in')">
							{{ $t('components.header.login') }}
						</ButtonOutlined>
						<ButtonOutlined v-else class="header-topbar__login-btn" :to="localePath('account')">
							{{ $t('components.header.account') }}
						</ButtonOutlined>
						<LazyGlobalLanguageSelect v-if="!isTablet_lg" compact class="header-topbar__lang-select" />
						<LazyCurrencySelect v-if="!isTablet_lg" compact class="header-topbar__currency-select" />
					</ClientOnly>
				</div>
			</div>
		</div>

		<header ref="navRef" class="header">
			<div class="header__container">
				<GlobalHeaderNav />
				<div class="header__buttons-container">
					<ButtonPrimary class="header__call-btn" :href="'tel:+48794500550'" rel="nofollow">
						<span
							><span class="header__call-btn__hotline">{{ $t('components.header.infoline') }}</span> 24/7</span
						>
						<div class="header__call-btn-icon">
							<GlobalIcon name="call" :height="isMobile_lg ? 14 : 18" :width="isMobile_lg ? 14 : 18" />
						</div>
						<span class="header__call-btn__phone">+48 794 500 550</span>
					</ButtonPrimary>
					<ButtonOutlined v-if="!userStore.getUser" class="header__login-btn" :to="localePath('sign-in')">
						<span class="header__login-btn-label header__login-btn-label--wide">{{ $t('components.header.login') }}</span>
						<span class="header__login-btn-label header__login-btn-label--narrow">{{ $t('components.header.login_short') }}</span>
					</ButtonOutlined>
					<ButtonOutlined v-else class="header__login-btn" :to="localePath('account')">
						{{ $t('components.header.account') }}
					</ButtonOutlined>
					<button
						class="header__menu-btn"
						:class="{ 'header__menu-btn--opened': isMobileMenuOpen }"
						:aria-label="isMobileMenuOpen ? 'Zamknij menu' : 'Otwórz menu'"
						:aria-expanded="isMobileMenuOpen"
						@click="openMenu">
						<GlobalIcon name="menu" :height="28" class="header__menu-open-icon" />
						<GlobalIcon name="close" :height="28" class="header__menu-close-icon" />
					</button>
				</div>
			</div>
		</header>
	</div>

	<ClientOnly>
		<LazyGlobalMegaMenuMobile v-if="isTablet_lg && hasMenuBeenOpened" />
	</ClientOnly>

	<GlobalHeaderStickyBooker v-if="props.booker" />
</template>

<script setup lang="ts">
const isMobileMenuOpen = ref(false)
const hasMenuBeenOpened = ref(false)
const { isMobile_lg, isTablet_lg } = useWindowWidth()
const userStore = useUserStore()
const localePath = useLocalePath()
const i18nService = usei18nService()

const { y: scrollY } = useWindowScroll()
const isTopBarVisible = useIsTopBarVisible()
const lastScrollY = ref(0)
const SCROLL_DIRECTION_THRESHOLD = 8

watch(scrollY, (newY) => {
	if (newY <= 0) {
		isTopBarVisible.value = true
		lastScrollY.value = newY
		return
	}
	const delta = newY - lastScrollY.value
	if (Math.abs(delta) < SCROLL_DIRECTION_THRESHOLD) return
	isTopBarVisible.value = delta < 0
	lastScrollY.value = newY
})

provide('isMobileMenuOpen', isMobileMenuOpen)
provide('isTopBarVisible', isTopBarVisible)

const props = defineProps<{
	booker?: boolean
	bookerShowSelector?: string
}>()

const openMenu = () => {
	if (!hasMenuBeenOpened.value) hasMenuBeenOpened.value = true
	isMobileMenuOpen.value = !isMobileMenuOpen.value
}

watch(
	() => isMobileMenuOpen.value,
	(newValue) => {
		if (newValue) document.body.style.overflow = 'hidden'
		else document.body.style.overflow = 'auto'
	},
)
</script>

<style scoped lang="scss" src="./Header.scss"></style>
